<template>
    <div>
        <div class="flex items-center flex-wrap">
            <base-pill :title="user.first_name + ' ' + user.last_name" class="bg-gray-300 flex items-center justify-between space-x-2 text-xs p-2 mb-0.5 " v-for="user in users" :key="user.id">
                <div class="whitespace-nowrap w-5/6 truncate">
                    {{ user.first_name }} {{ user.last_name }}
                </div>
                <button :disabled="isLoading" @click="removeUser(user.id)" class=" pl-1">
                    x
                </button>
            </base-pill>
            <div v-if="addingUser" class="flex items-center">
                <select name="" id="" v-model="userToAdd" @change="addUser" class="mb-0.5 mr-1 w-40 p-1 border rounded-md">
                    <option v-for="user in userOptions" :key="user.value" :value="user.value">{{ user.label }}</option>
                </select>
                <base-button-negative class="h-6 w-6 mb-0.5" @click="closeAddUser">
                    x
                </base-button-negative>
            </div>
            <div v-else>
                <base-button-affirmative @click="openAddUser" class="h-6 w-6 mb-0.5">
                    +
                </base-button-affirmative>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { addUserToContact, removeUserFromContact } from '@/services/Contact';
import { useToast } from 'vue-toast-notification';

const store = useStore()
const $toast = useToast()
const props = defineProps(['contact', 'userOptions'])

const emit = defineEmits(['refetch-contacts'])

const addingUser = ref(false)

const isLoading = ref(false)

function openAddUser(){
    addingUser.value = true
}
const userToAdd = ref(null)

async function addUser(){
    isLoading.value = true
    const token = store.state.auth.token
    const data = {
        user_id: userToAdd.value
    }
    const result = await addUserToContact(token, props.contact.id, data)
    if(result.status == 201){
        fetchNewContacts()
        addingUser.value = false
        $toast.open({
            message: `Successfully added user to contact`,
            type: 'success',
            duration: 3000
        })
    } else {
        $toast.open({
            message: `Error, could not add user to contact`,
            type: 'error',
            duration: 3000
        })
    }

}

async function removeUser(userId){
    isLoading.value = true
    const token = store.state.auth.token
    const data = {
        user_id: userId
    }
    const result = await removeUserFromContact(token, props.contact.id, data)
    if(result.status == 200){
        fetchNewContacts()
        addingUser.value = false
        $toast.open({
            message: `Successfully removed user from contact`,
            type: 'success',
            duration: 3000
        })
    } else {
        $toast.open({
            message: `Error, could not remove user from contact`,
            type: 'error',
            duration: 3000
        })
    }

}

const users = computed(() => {
    if(props.contact){
        return props.contact.users
    } else {
        return []
    }
})

watch(users, () => {
    isLoading.value = false
})


function closeAddUser() {
    addingUser.value = false
}

function fetchNewContacts () {
    emit('refetch-contacts')
}
</script>